/* unplugin-vue-components disabled */import { render } from "./SpeachSlider.vue?vue&type=template&id=58d03384&scoped=true&ts=true"
import script from "./SpeachSlider.vue?vue&type=script&lang=ts"
export * from "./SpeachSlider.vue?vue&type=script&lang=ts"

import "./SpeachSlider.vue?vue&type=style&index=0&id=58d03384&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d03384"]])

export default __exports__